<template>
    <div class="container_box" :style="backgroundDiv">
        <div class="left_box">
        <div class="left_title_img"><img :src="titleImgSrc" width="100%" height="100%" alt="" /></div>
        <div class="left_title_txt">RIDE TO THE TOP</div>
        <div class="left_title_desc">EPISODE 3</div> 
        <div v-for="(item, index) in topThreeList" :key="index">
            <div class="left_item_box">
            <div class="left_item_content">
                <div class="left_avatar_box">
                <div v-if="index==0">
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_0" />
                    </div>
                </div>
                <div v-if="index==1">
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_1" />
                    </div>
                </div>
                <div v-if="index==2">
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_2" />
                    </div>
                </div>
                </div>
                <div class="left_name_value">
                <div class="left_name">{{item.userName}}</div>
                <div class="left_value" v-if="index == 0">{{item.score}}</div>
                <div class="left_value_1" v-if="index == 1">{{item.score}}</div>
                <div class="left_value_2" v-if="index == 2">{{item.score}}</div>
                </div>
            </div>
            <div v-if="index == 0">
                <div class="left_rank_no"><img :src="rankNoFirstSrc" width="100%" height="100%"></div>
            </div>
            <div v-if="index == 1">
                <div class="left_rank_no"><img :src="rankNoSencodSrc" width="100%" height="100%"></div>
            </div>
            <div v-if="index == 2">
                <div class="left_rank_no"><img :src="rankNoThridSrc" width="100%" height="100%"></div>
            </div>
            </div>
        </div>
        </div>
        <div class="right_box">
        <div class="right_top_title_box">
            <!-- <div class="right_top_title">Real time ranking as of</div> -->
            <div class="right_top_time">{{laveDay}}<span>day</span>{{laveHours}}
            <span>hours</span>{{laveMinutes}}<span>minutes</span>{{laveSeconds}}<span>seconds left</span>
            </div>
        </div>
        <div class="right_title_box">
            <div class="right_rank_title">Rank </div>
            <div class="right_name_title">Username </div>
            <div class="right_points_title">Points </div>
        </div>
        <div v-for="(item, index) in ranksList" :key="index">
            <div v-if="item.userName != myself.userName" class="right_item_box">
            <div class="right_rank_box">{{item.rankNum }}</div>
            <div class="right_avatar_name">
                <div class="right_avatar">
                    <div v-if="itemsContains(item.userAvatar)">
                        <img :src="item.userAvatar" width="100" height="100" class="right_avatar_img" />
                    </div>
                    <div v-else>
                        <img :src="defaultHead" width="100" height="100" class="right_avatar_img" />
                    </div>
                </div>
                <div class="right_name_box">{{item.userName}}</div>
            </div>
            <div class="right_points_box">{{ item.score }} </div>
            </div>
            <div class="right_item_box_self" v-else>
            <div class="right_my_self_no">{{item.rankNum }}</div>
            <div class="right_avatar_name">
                <div class="right_my_self_name">You Currently Rank</div>
            </div>
            <div class="right_my_self_points">{{ item.score }} </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
  import http from '../api/http';
  import {
    Message
  } from 'element-ui';
  import utils from '../utils/numberUtils';
  export default {
    name: 'TotalRanking',
    data() {
      return {
        backgroundDiv: {
          backgroundImage: 'url(' + require('../assets/match-bg.png') + ')'
        },
        titleImgSrc: require('../assets/match-title.png'),
        rankNoFirstSrc: require('../assets/number-1.png'),
        rankNoSencodSrc: require('../assets/number-2.png'),
        rankNoThridSrc: require('../assets/number-3.png'),
        upSrc: require('../assets/up_arrow.png'),
        defaultHead: require('../assets/default-head.png'),
        ranksList: [],
        topThreeList: [],
        myself: {},
        timer: null,
        endTime: 0,
        laveDay: 0,
        laveHours: 0,
        laveMinutes: 0,
        laveSeconds: 0
      }
    },
    methods: {
        async getGameInfoEvent()  {
            await http.get('client-api/v1/game/info', {}).then((res) => {
                if (res.data.code == 200) {
                    let data = res.data.data;
                    this.endTime = data.endTime;
                } else {
                    Message.error(res.data.msg);
                    return
                }
            }).catch (error => {
                Message.error(error);
            })
        },
      async getRanking() {
        let query = this.$route.query;
        let name = query.name;
        let params = {
          'userName': name
        } //wzlk client-api/v1/game/rank
        await http.get('client-api/v1/game/rank', params).then(res => {
            if (res.data.code != 200) {
              Message.error(res.data.msg)
              return
            } else {
              let resource = res.data.data
              var newList = []
              var newArray = []

              resource.forEach((item, index) => {
                var map = item
                map['score'] = utils.numberFormat(item.score)
                if (index < 3) {
                  newList.push(map)
                } else {
                  newArray.push(map)
                }
                if (item.userName == name) {
                  this.myself = item
                }
              });
              if (newList.length > 1) {
                this.mTopOneAvatar = newList[0].userAvatar;
              }
              if (newList.length > 2) {
                this.mTopOneAvatar = newList[1].userAvatar;
              }
              if (newList.length > 3) {
                this.mTopOneAvatar = newList[2].userAvatar;
              }
              this.topThreeList = newList;

              this.ranksList = newArray;
            }

            console.log(res);
          })
          .catch(error => {
            throw error
          })
      },
      getCurrentTime() {
        const endTimeDate = this.endTime/1000;
        const nowTimeDate = new Date().getTime()/1000;
        if(nowTimeDate <= endTimeDate) {
          //获取时间差
          let timediff = Math.round((endTimeDate-nowTimeDate));
          //获取还剩多少天
          let day = parseInt(timediff/3600/24);
          this.laveDay = day < 10 ? '0' + day : day;
          //获取还剩多少小时
          let hours =  parseInt(timediff/3600%24);
          this.laveHours = hours < 10 ? '0' + hours : hours;
          //获取还剩多少分钟
          let minutes = parseInt(timediff/60%60);
          this.laveMinutes = minutes < 10 ? '0' + minutes : minutes;
          //获取还剩多少秒
          let seconds = timediff%60;
          this.laveSeconds = seconds < 10 ? '0' + seconds : seconds;
        }
      },
      itemsContains(val){
          return val.indexOf('http') > -1
      }
    },
    mounted() {
        this.getGameInfoEvent();
        this.timer = setInterval(() => {
            this.getCurrentTime();
        }, 1000);

        this.getRanking();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<style scoped>
  @import '../fonts/font.css';
  /** this is PC Style */
  .container_box {
    font-weight: normal;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    padding-top: 64px;
    padding-bottom: 108px;
    min-width: 1080px;
    width: 100%;
    height: 100%;
  }

  .left_box {
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 40px;
  }

  .left_title_img {
    width: 55%;
    /* margin-bottom: 90px; */
  }

  .left_title_txt {
    color: #fff;
    font-size: 25px;
    font-weight: 400;
    margin-top: 20px;
    /* margin-bottom: 40px; */
    font-family: Montserrat-Medium;
  }
  .left_title_desc {
    margin-top: 2px;
    margin-bottom: 34px;
    font-size: 20px;
    font-family: Montserrat-Regular, Montserrat;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    line-height: 48px;
  }

  .left_item_box {
    width: 26.25rem;
    position: relative;
  }

  .left_item_content {
    width: 100%;
    height: 168px;
    background-color: #473654;
    border-radius: 8px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .left_avatar_box {
    width: 46%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }

  .left_avator_tag {
    width: 74px;
    height: 67px;
    position: absolute;
    top: 0px;
    left: 108px;
  }

  .left_avator {
    width: 86px;
    height: 86px;
    border-radius: 50%;
    position: relative;
    margin-left: 10px;
  }

  .left_avator_img_0 {
    border-radius: 50%;
    border: 3px solid #FF9A00;
  }

  .left_avator_img_1 {
    border-radius: 50%;
    border: 3px solid #00BFE8;
  }

  .left_avator_img_2 {
    border-radius: 50%;
    border: 3px solid #FF4DA3;
  }

  .left_name_value {
    width: 54%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
  }

  .left_name {
    width: 180px;
    font-size: 16px;
    font-weight: 400;
    color: rgb(255, 255, 255, 0.8);
    font-family: Montserrat-Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .left_value {
    font-size: 40px;
    font-weight: 500;
    color: #FF9A00;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_value_1 {
    font-size: 40px;
    font-weight: 500;
    color: #00BFE8;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_value_2 {
    font-size: 40px;
    font-weight: 500;
    color: #FF4DA3;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_rank_no {
    width: 3.75rem;
    height: 3.75rem;
    position: absolute;
    left: -7%;
    top: 35%;
  }

  .right_box {
    width: 65%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-right: 120px;
    color: rgb(255, 255, 255, 0.8);
    font-size: 16px;
    margin-left: 40px;
  }

  .right_top_title_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .right_top_title {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 50px;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .right_top_time {
    font-size: 60px;
    color: #4949C5;
    line-height: 50px;
    margin-left: 18px;
    font-family: DINCond-Bold;
    font-weight: 500;
  }
  .right_top_time>span {
    margin-left: 8px;
    margin-right: 33px;
    color: rgb(255, 255, 255, 0.8);
    font-size: 16px;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }
  .right_title_box {
    display: flex;
    flex-direction: row;
    height: 56px;
    align-items: center;
    font-size: 16px;
    color: rgb(255, 255, 255, 0.8);
    margin-top: 18px;
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

  .right_rank_title {
    width: 20%;
  }

  .right_name_title {
    width: 60%;
    text-align: left;
    margin-left: 85px;
  }

  .right_points_title {
    width: 20%;
    text-align: right;
    margin-right: 100px;
  }

  .right_item_box {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: rgb(255, 255, 255, 0.15);
    border-radius: 4px;
    margin-top: 15px;
  }

  .right_item_box_self {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #303095;
    border-radius: 4px;
    margin-top: 15px;
  }

  .right_rank_box {
    width: 20%;
    font-size: 20px;
    font-weight: 500;
    color: rgb(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
  }

  .right_item_my_self {
    display: flex;
    flex-direction: row;
    width: 50%;
  }

  .right_myself_name,
  .right_avatar_name {
    display: flex;
    flex-direction: row;
    width: 50%;
  }

  .right_my_self_no {
    width: 20%;
    font-size: 24px;
    font-family: Montserrat-Bold;
    font-weight: bold;
    color: #FFFFFF;
  }

  .right_my_self_name {
    width: auto;
    text-align: left;
    font-family: Montserrat-Medium;
    font-weight: 600;
  }

  .right_my_self_points {
    width: 30%;
    font-size: 36px;
    color: rgb(255, 255, 255, 0.8);
    margin-left: 60px;
    font-family: DINCond-Bold;
    font-weight: bold;
    text-align: right;
    margin-right: 100px;
  }

  .right_avatar {
    text-align: right;
  }

  .right_avatar_img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
  }

  .right_name_box {
    width: 50%;
    text-align: left;
    margin-left: 40px;
    align-self: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .right_points_box {
    width: 30%;
    font-size: 30px;
    font-weight: 500;
    color: rgb(255, 255, 255, 0.8);
    margin-left: 60px;
    font-family: DINCond-Bold;
    font-weight: bold;
    text-align: right;
    margin-right: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/TotalRanking.vue